/**
 * @file loading-context.js
 * @description Contexto de loading (CRA)
 */

import { createContext } from "react"

/**
 * Contexto de loading
 */
export const LoadingContext = createContext(undefined)
